import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography,Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DriverNavBar from '../NavigationBar/DriverNavBar';
import supabase from '../../supabaseClient';
import DriverAttendanceGateKeeper from './DriverAttendanceGateKeeper';

const DriverMainView = () => {

  const [userID, setUserID] = useState('');
  const [idConfig, setIdConfiguration] = useState('');
  const [hiddenSimpleLocationConfirmation, setHiddenSimpleLocationConfirmation] = useState(null);
useEffect(() => {
  const checkSession = async () => {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      setUserID(data.session.user.id);
      fetchData(data.session.user.id);
    }
  };
  checkSession();
}, []);

const fetchData = async (userId) => {
  const { data: profileData, error: profileError } = await supabase
    .from('profiles')
    .select('id_configuration')
    .eq('id', userId)
    .single();
  if (profileError) {
    console.log(profileError);
  } else if (profileData) {
    setIdConfiguration(profileData.id_configuration);
  }
};





  return (
    <DriverNavBar>
      <DriverAttendanceGateKeeper></DriverAttendanceGateKeeper>
    </DriverNavBar>
  );
};

export default DriverMainView;
